(() => {
  'use strict';
  function setup(scope=document) {
    scope.querySelectorAll('[data-tampons-parts]').forEach(section => {
      if(section.dataset.ready)return;
      section.dataset.ready='true';
      const buttons=[...section.querySelectorAll('[data-layer-button]')];
      function activate(index){
        buttons.forEach(button=>{const active=button.dataset.layerButton===index;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});
        section.querySelectorAll('[data-layer-panel]').forEach(panel=>{const active=panel.dataset.layerPanel===index;panel.classList.toggle('is-active',active);panel.hidden=!active;});
        section.querySelectorAll('[data-stack-layer]').forEach(layer=>layer.classList.toggle('is-active',layer.dataset.stackLayer===index));
      }
      buttons.forEach(button=>button.addEventListener('click',()=>activate(button.dataset.layerButton)));
      section.addEventListener('shopify:block:select',event=>{const button=event.target.closest('[data-layer-button]');if(button)activate(button.dataset.layerButton);});
    });
  }
  if(!window.__tamponsPartsReady){
    window.__tamponsPartsReady=true;
    document.addEventListener('shopify:section:load',event=>setup(event.target));
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(),{once:true});
  }
  setup();
})();
